(function ($, Drupal) {
  'use strict';

  Drupal.behaviors.FareharborScript = {
    attach: function (context) {

      $( window ).on('load', function() {
        getFarharborScript();
      });

    }
  };

  function getFarharborScript() {
    $.getScript( "https://fareharbor.com/embeds/api/v1/?autolightframe=yes" )
      .then(function( script, textStatus ) {
        // console.log( 'in har ' +textStatus );
      })
      .fail(function( jqxhr, settings, exception ) {
        /// $( "div.log" ).text( "Triggered ajaxError handler." );
        console.log( 'Triggered ajaxError handler' );
    });
  }
}(jQuery, Drupal));